import { useEffect, useState } from "react";
import moment from "moment";
import style from "./DateSelection.module.scss";
import { FaChevronRight, FaChevronLeft, FaCheck } from "react-icons/fa";
import Loader from "components/miscellaneous/Loader/Loader";

export const minuteTimeSlot = 30;

const DateSelection = ({ onChange, label, dailyWorkingHoursRange, maxHeight, dateValue, useDefaultTime, checkAvailableTimes, staffId }) => {
    const [ date, setDate ] = useState();
    const [ selectedDate, setSelectedDate ] = useState();
    const [ selectedTime, setSelectedTime ] = useState(null);
    const [ visibleDates, setVisibleDates ] = useState([]);
    const [booted, setBooted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [availableTimes, setAvailableTimes] = useState({});
    const defaultDailyOpenHours = [ '09:00', '17:00' ]
    const datesToView = 5;

    const nextDates = () => {
        setSelectedDate(date.clone().add(datesToView, 'days'))
    }

    const prevDates = () => {
        setSelectedDate(date.clone().subtract(datesToView, 'days'))
    }

    const getVisibleDates = () => {
        setVisibleDates([ ...Array(datesToView).keys() ].map((i) => {
            return selectedDate.clone().add(i, 'days')
        }));
    }

    const getFirstAvailableDay = () => {
        let firstAvailableDay = null;
        let i = 0;

        while(firstAvailableDay === null && i < 300) {
            const day = moment().add(i, 'days');
            if(getTimeRange(day).length > 0) {
                firstAvailableDay = day
            }
            i++;
        }

        return firstAvailableDay
    }

    const getDailyWorkingHours = (d) => {
        const dayNumber = d.clone().day();
        if (dailyWorkingHoursRange[ dayNumber ]) {
            return [ dailyWorkingHoursRange[ dayNumber ].open, dailyWorkingHoursRange[ dayNumber ].close ]
        }

        return defaultDailyOpenHours;
    }

    const getTimeRange = (day = null) => {
        const d = day !== null ? day : date;

        if(d !== null && d !== undefined) {
            const workingHours = getDailyWorkingHours(d);
            if (workingHours[ 0 ] && workingHours[ 1 ]) {
                const start = moment(`${d.format('YYYY-MM-DD')} ${workingHours[ 0 ]}`);
                const end = moment(`${d.format('YYYY-MM-DD')} ${workingHours[ 1 ]}`);
                const duration = moment.duration(end.diff(start));
                const minutes = duration.asMinutes() > 0 ? Math.round(duration.asMinutes()) : 0;
                const now = moment().local().add(1, 'hours');
                
                const slots = Math.round(minutes / minuteTimeSlot);

                const times = [ ...Array(slots).keys() ].map(function (i) {
                    const d = start.clone().add((i * minuteTimeSlot), 'minutes');
                    return d > now ? d : false;
                })

                const availableTimesForDay = availableTimes !== null ? availableTimes[ d.format('YYYY-MM-DD') ] : null;
                const availableTimeRange = Array.isArray(availableTimesForDay) ? availableTimesForDay.map(t => {
                    return moment(`${d.format('YYYY-MM-DD')} ${t}`)
                }).filter(t => t > now) : times.filter(t => t !== false);

                return availableTimeRange;
            }
        } 
        
        return []
    }

    useEffect(() => {
        const firstAvailableDay = getFirstAvailableDay();
        if(dateValue) {
            setSelectedDate(moment(dateValue));
        } else {
            if(firstAvailableDay) {
                setSelectedDate(firstAvailableDay);
            }
        }
        
    }, [])

    useEffect(() => {
        if (selectedDate) {
            if (selectedDate !== date) {
                setDate(selectedDate);
            }

            getVisibleDates()
        }
    }, [ selectedDate ])

    useEffect(() => {
        if((booted === true && useDefaultTime === true) || useDefaultTime !== true) {
            setSelectedTime(null)
        } else {
            if(useDefaultTime && date) {
                setSelectedTime(date.clone().format('HH:mm'))
            }
        }

        if(date && !booted) {
            setBooted(true);
        }
    }, [ date ])

    useEffect(() => {
        if (date && selectedTime) {
            onChange(moment(`${date.format('YYYY-MM-DD')} ${selectedTime}`))
        } else {
            onChange(null)
        }
    }, [ date, selectedTime ])

    useEffect(() => {
        if(checkAvailableTimes) {
            if(visibleDates.length > 0) {
                setIsLoading(true);
                checkAvailableTimes({
                    start: visibleDates[ 0 ].format('YYYY-MM-DD HH:mm'),
                    end: visibleDates[ visibleDates.length - 1 ].format('YYYY-MM-DD HH:mm')
                }).then(res => {
                    setAvailableTimes(res);
                    setIsLoading(false);
                })
            }
        }
    }, [visibleDates, staffId])

    return (<div className={ style.container }>
        { isLoading && <div className={ style.loading }>
            <Loader color="#ddd" />
        </div> }
        { label && <div className={ style.label }>{ label }</div> }
        <div className={ style.dateMenu }>
            <div className={ style.menuButtonWrapper }>
                <button onClick={ (e) => {
                    prevDates()
                } } className={ style.menuButton }>
                    <FaChevronLeft />
                </button>
            </div>
            <div className={ style.dates }>
                { visibleDates.map((currentDate, i) => {
                    const isSelected = currentDate.isSame(date, 'day');
                    const workingHours = getTimeRange(currentDate);
                    const isDisabled = workingHours.length === 0;

                    return (<div onClick={ (e) => {
                        if(!isDisabled) {
                            setDate(currentDate);
                        }

                    } } className={ [ style.date, isSelected && style.selected, isDisabled && style.disabled ].join(' ') } key={ i }>
                        <div className={ style.dateLabel }>
                            { currentDate.format('ddd') }
                        </div>
                        <div className={ style.dateNumberLabel }>
                            { currentDate.format('DD') }
                        </div>
                    </div>)
                }) }
            </div>
            <div className={ style.menuButtonWrapper }>
                <button onClick={ (e) => {
                    nextDates()
                } } className={ style.menuButton }>
                    <FaChevronRight />
                </button>
            </div>
        </div>
        <div className={ style.dateTimeList } style={maxHeight ? {
            maxHeight: maxHeight,
            overflowY: 'scroll'
        } : {}}>
            { getTimeRange().map((time, i) => {
                const isSelected = selectedTime && time.clone().format('HH:mm') === selectedTime;

                return (<div onClick={ (e) => {
                    setSelectedTime(time.clone().format('HH:mm'))
                } } className={ [ style.dateTime, isSelected && style.selected ].join(' ') } key={ i }>
                    <span>{ isSelected && <FaCheck /> }</span>
                    { time.clone().format('HH:mm') } <FaChevronRight /> { time.clone().add(minuteTimeSlot, 'minutes').format('HH:mm') }
                </div>
                )
            }) }
        </div>
    </div>)
}

export default DateSelection;